<template>
  <svg
    width="44px"
    height="54px"
    viewBox="0 0 44 54"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="location-activities-job-sites-panel-open-selection"
        transform="translate(-843.000000, -396.000000)"
      >
        <g id="app">
          <g
            id="location-1"
            transform="translate(622.000000, 375.000000)"
          >
            <g
              id="job-site"
              transform="translate(223.000000, 23.000000)"
            >
              <path
                id="marker"
                d="M20,-1 C14.2010101,-1 8.95101013,1.35050506 5.1507576,5.1507576 C1.35050506,8.95101013 -1,14.2010101 -1,20 C-1,24.6562524 0.515615459,28.9584445 3.07996112,32.4405683 C5.63990966,35.9167213 9.24567448,38.5750001 13.4327166,39.9523982 L19.9999445,49.8026129 L26.5682639,39.9520756 C30.7550664,38.5745265 34.3605967,35.9162239 36.9203653,32.4401251 C39.4845131,28.9580794 41,24.6560548 41,20 C41,14.2010101 38.6494949,8.95101013 34.8492424,5.1507576 C31.0489899,1.35050506 25.7989899,-1 20,-1 Z"
                stroke="#FFFFFF"
                stroke-width="2"
                :fill="fillColor"
              ></path>
              <path
                id="organizations"
                d="M23,22 L26,22 L26,22 L26,20 L23,20 C22.4477153,20 22,20.4477153 22,21 C22,21.5522847 22.4477153,22 23,22 Z M23,18 L26,18 L26,18 L26,16 L23,16 C22.4477153,16 22,16.4477153 22,17 C22,17.5522847 22.4477153,18 23,18 Z M26,14 L26,26 L20,26 L20,14 L26,14 Z M18,18 L18,26 L14,26 L14,18 L18,18 Z M12,26 L12,18 C12,16.8954305 12.8954305,16 14,16 L18,16 L18,16 L18,14 C18,12.8954305 18.8954305,12 20,12 L26,12 C27.1045695,12 28,12.8954305 28,14 L28,26 C28,27.1045695 27.1045695,28 26,28 L14,28 C12.8954305,28 12,27.1045695 12,26 Z"
                fill="#FFFFFF"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    fillColor: {
      type: String,
      required: true,
    },
  },
};
</script>
